import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { Button } from '../components/Button';
import { ArrowLeft } from 'lucide-react';
interface Slide13Props {
  onBack: () => void;
}
export function Slide13({
  onBack
}: Slide13Props) {
  return <SlideLayout footer="¹ Vabysmo® Summary of Product Characteristics (SmPC/RCP), May 2024." progress={{
    current: 1,
    total: 1
  }} onBack={onBack} data-id="element-116">
      <div className="w-full max-w-4xl mx-auto space-y-8" data-id="element-117">
        <h1 className="text-3xl font-bold text-white text-center mb-6 uppercase" data-id="element-118">
          INDIVIDUALISED TREATMENT APPROACH
        </h1>
        <div className="frosted-card rounded-2xl shadow-xl p-12" data-id="element-119">
          <p className="text-2xl text-white text-center leading-relaxed font-medium" data-id="element-120">
            Vabysmo<sup data-id="element-121">®</sup> is used within a Treat-and-Extend approach,
            allowing treatment intervals to be adapted based on disease
            activity, according to clinical assessment.<sup data-id="element-122">¹</sup>
          </p>
        </div>
        <div className="flex justify-center pt-4" data-id="element-123">
          <Button variant="primary" onClick={onBack} data-id="element-124">
            BACK TO MENU
          </Button>
        </div>
      </div>
    </SlideLayout>;
}